import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Page, Card, DataTable, AppProvider, Link, Button, ButtonGroup, ResourceList, Badge, Banner, Select, Checkbox, Pagination, Spinner } from '@shopify/polaris';
import FilterTableProvider from '@container/FilterTableProvider';

import { orderSuppliesColumns } from 'utils/recordHelpers'

const propTypes = {
  supplies: PropTypes.array.isRequired,
  newURL: PropTypes.string,
  isAdmin: PropTypes.bool,
  maintenanceMode: PropTypes.bool,
};


class OrderSupplyIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderSuppliesColumns: orderSuppliesColumns(props.isAdmin)
    }

  }
  render() {

    const { sellers, totalPages, supplies } = this.props;

    return (
      <FilterTableProvider
        pageProps={{
          title: I18n.t("activerecord.models.order_supply.other"),
        }}
        users={ this.props.sellers }
        filterByCreation
        paramsName="filters"
        searchName="search_query"
        searchPlaceholder={ I18n.t("form.placeholder.order_supply_search") }
        filterURL="/order_supplies"
        itemURL="/order_supplies"
        tabs={ this.props.tabs }

        initialFilters={{
          user_id: (sellers.length > 0) && sellers[0].value,
          start_date: new Date(),
          end_date: new Date(),
          search_query: '',
        }}
        initialTotalPages={ totalPages }
        initialRecords={ supplies }
        resourceTableProps = {{
          conditionalRowClass: this.conditionalRowClass,
        }}

        columnsInfo={ this.state.orderSuppliesColumns }
      >
        { () => this.props.maintenanceMode &&
          <Banner title={ I18n.t("order_supply.maintenance.title") } status="warning">
            <p>{ I18n.t("order_supply.maintenance.description") }</p>
          </Banner>
        }
      </FilterTableProvider>
    );
  }

  conditionalRowClass = (orderSupply) => {
    const cancelled = orderSupply.status == "cancelled";
    return `${ cancelled ? "cancelledItem" : "" }`
  }

}


OrderSupplyIndex.propTypes = propTypes;


export default OrderSupplyIndex;
